import * as React from "react";
import {
    Card,
    CardActions,
    CardContent,
    Grid,
    Typography,
} from "@mui/material";
import { SxProps } from "@mui/system";
import { Theme } from "@mui/material/styles";

interface Props {
    children: React.ReactNode;
    actions?: React.ReactNode;
    sx?: SxProps<Theme>;
    contentSx?: SxProps<Theme>;
}

export default (p: Props) => (
    <Card sx={p.sx}>
        <CardContent sx={p.contentSx}>{p.children}</CardContent>
        {p.actions && (
            <CardActions
                sx={{
                    justifyContent: "flex-end",
                    padding: 2,
                    // borderTop: 1,
                    // borderColor: (theme) => theme.borderColor,
                    // // backgroundColor: (theme) => theme.surfaceColor.topLevel,
                }}
            >
                {p.actions}
            </CardActions>
        )}
    </Card>
);

interface SectionHeadingProps {
    heading: string;
    right?: React.ReactNode;
}

export const SectionHeading = (p: SectionHeadingProps) => (
    <Grid container justifyContent={"space-between"} sx={{ pb: 2 }}>
        <Grid item>
            <Typography variant={"h6"}>{p.heading}</Typography>
        </Grid>
        {p.right == null ? null : <Grid item>{p.right}</Grid>}
    </Grid>
);
